import { useAuth } from "~/hooks/useAuth";

export default function DemoBanner() {
  const { isGuest, logout } = useAuth();
  if (!isGuest) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-accent-cyan/15 border-b border-accent-cyan/30 text-text-primary">
      <div className="max-w-content mx-auto px-6 lg:px-10 py-1.5 flex items-center justify-center gap-3 text-xs font-body">
        <span className="font-heading uppercase tracking-wider text-accent-cyan">
          Demo mode
        </span>
        <span className="text-text-secondary hidden sm:inline">
          You're exploring as a guest with sample data.
        </span>
        <button
          onClick={logout}
          className="underline underline-offset-2 text-accent-cyan hover:text-accent-hover transition-colors"
        >
          Exit demo
        </button>
      </div>
    </div>
  );
}
